export const numericDateOptions: Intl.DateTimeFormatOptions = { year: "numeric", month: "numeric", day: "numeric" };
export const numericDateTimeOptions: Intl.DateTimeFormatOptions = {
  year: "2-digit",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
};

export const trimEndDate = (endDate: string) => endDate.replace("T23:59:59.999", "");

export const formatDate = (date: string, options: Intl.DateTimeFormatOptions) =>
  new Date(date).toLocaleDateString("en-GB", options).replaceAll("/", ".");

export const STEPS = {
  deal: "Deal",
  payment: "Payment",
  product_transfer: "Product transfer",
  dispute: "Dispute",
  product_return: "Product return",
  payout: "Payout",
  deposit: "Deposit",
  compensation: "Compensation",
  dispute_request: "Dispute",
  debt: "Debt",
};

export const FILE_NAMES = {
  deal: "Rental Agreement",
  payment: "Payment Invoice",
  product_transfer: "Transfer Act",
  product_return: "Return Act",
  payout: "Payout Invoice",
  dispute_request: "Dispute Report",
  debt: "Debt Report",
  cancelation: "",
};

export const getRightDocumentName = (step: string) => {
  return FILE_NAMES[step];
};

export const getIsDateOn = (step: string) => {
  switch (step) {
    case "payment":
      return false;
    default:
      return true;
  }
};
